import React from "react";
import * as PropTypes from "prop-types";
import AppBarCustom from "./AppBarCustom";
import AppContent from "./AppContent";

const App = (props) => {
    const { onChangeLanguage, onLogout } = props;

    return (
        <>
            <AppBarCustom
                onChangeLanguage={onChangeLanguage}
                onLogout={onLogout}
            />

            <AppContent />
        </>
    );
};

App.propTypes = {
    onChangeLanguage: PropTypes.func.isRequired,
    onLogout: PropTypes.func.isRequired,
};

export default App;
